import { render } from "./ScrollStory.vue?vue&type=template&id=1c8728a9"
import script from "./ScrollStory.vue?vue&type=script&lang=js"
export * from "./ScrollStory.vue?vue&type=script&lang=js"

import "./ScrollStory.vue?vue&type=style&index=0&id=1c8728a9&lang=scss"

import exportComponent from "/Users/kakkote/Mediadeski/2022-01-aluevaalit-kompassianalyysi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__